import { Divider, Typography } from '@mui/material';
import CustomDialog from '../../../../../../components/dialog/CustomDialog';
import './StudentAssignmentDialog.scss';
import StudentAssignment from './StudentAssignment';
import DateUtils from '../../../../../../utils/DateUtils';
import { dateFormatyyyyMMdd } from '../../../../../../AppConstants';
import { filterUndefined } from '../../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  open: false,
  onClose: () => null,
  onTableActionSuccess: () => null,
  loading: false,
};
const StudentAssignmentDialog = (p) => {
  const {
    open,
    data,
    onClose,
    onTableActionSuccess,
    loading,
  } = { ...defaultProps, ...filterUndefined(p) };
  return (
    <CustomDialog
      openDialog={open}
      className='assignment-overview-student-assignment-dialog'
      onClose={onClose}
      title={(
        <div className='title'>
          <Typography variant='h5' gutterBottom>
            Assignments For
          </Typography>
          <Typography variant='h4' gutterBottom>
            {DateUtils.convertDateString(data.date, dateFormatyyyyMMdd, 'iii, LLLL d')}
          </Typography>
          <Divider />
        </div>
      )}
      content={(
        <StudentAssignment loading={loading} data={data} onTableActionSuccess={onTableActionSuccess} />
      )}
      displayCloseIcon
    />
  );
};

export default StudentAssignmentDialog;
